import { useEffect, useRef } from 'react';

//keeps canvas drawing ratios clean
//http://www.petecorey.com/blog/2019/08/19/animating-a-canvas-with-react-hooks/
const getPixelRatio = context => {
    var backingStore =
        context.backingStorePixelRatio ||
        context.webkitBackingStorePixelRatio ||
        context.mozBackingStorePixelRatio ||
        context.msBackingStorePixelRatio ||
        context.oBackingStorePixelRatio ||
        context.backingStorePixelRatio ||
        1;

    return (window.devicePixelRatio || 1) / backingStore;
};


export default function RankShotsCanvas(props) {
    const canvasRef = useRef(null)

    useEffect(() => {
        const canvas = canvasRef.current;
        const context = canvas.getContext('2d');

        let ratio = getPixelRatio(context);
        let width = getComputedStyle(canvas)
            .getPropertyValue('width')
            .slice(0, -2);
        let height = getComputedStyle(canvas)
            .getPropertyValue('height')
            .slice(0, -2);

        canvas.width = width * ratio;
        canvas.height = height * ratio;
        canvas.style.width = `${width}px`;
        canvas.style.height = `${height}px`;

        drawBackground(context, canvas);
    })

    function canvas_arrow(context, fromx, fromy, tox, toy) {
        var headlen = 10; // length of head in pixels
        var dx = tox - fromx;
        var dy = toy - fromy;
        var angle = Math.atan2(dy, dx);
        context.moveTo(fromx, fromy);
        context.lineTo(tox, toy);
        context.lineTo(tox - headlen * Math.cos(angle - Math.PI / 6), toy - headlen * Math.sin(angle - Math.PI / 6));
        context.moveTo(tox, toy);
        context.lineTo(tox - headlen * Math.cos(angle + Math.PI / 6), toy - headlen * Math.sin(angle + Math.PI / 6));
        context.stroke();
    }

    function drawBackground(ctx, canvas) {

        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.lineWidth=2;
        ctx.strokeStyle = 'black';
        ctx.font = '20px arial';
        //up arrow
        canvas_arrow(ctx, canvas.width * .60, canvas.height * .45, canvas.width * .60, canvas.height * .15)
        //down arrow
        canvas_arrow(ctx, canvas.width * .60, canvas.height * .6, canvas.width * .60, canvas.height * .9)
    }

    return (
        <>
            <canvas className="canvas-rankshots" ref={canvasRef} {...props} /><br />
        </>
    )
}